// extracted by mini-css-extract-plugin
export var checkbox = "_52-0";
export var circle = "_52-3";
export var horizontalContainer = "_52-7";
export var sm = "_52-5";
export var switch0 = "_52-2";
export var switchDisabled = "_52-8";
export var switchEnabled = "_52-1";
export var textSwitchContainer = "_52-9";
export var textSwitchOption = "_52-a";
export var textSwitchOptionSelected = "_52-b";
export var verticalContainer = "_52-6";
export var xs = "_52-4";